module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms6-7f69e3f864d897cc203412cef71e6f77.jpg";